import React from "react";
import { Navigate, useParams } from "react-router-dom";
import projects from "../data/projects.json";
import PublicTable from "./PublicTable";

export default function ProjectPage() {
  const { projectId } = useParams();
  return projects.some(project => project.id === projectId)
    ? <PublicTable projectId={projectId} />
    : <Navigate to="/projects" replace />;
}